exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.crearGeneralMovimiento #alinear[data-v-f90eafc6] {\n  text-align: justify;\n}\n.crearGeneralMovimiento .h2_title[data-v-f90eafc6] {\n  font-weight: normal;\n}\n", ""]);

// exports
